module.exports = __webpack_public_path__ + "img/developers-037be93fca5d464cf0a926fed1c2c4f2.svg";